import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";

import PageTitle from 'components/PageTitle';
import Pagination from 'components/Pagination';
import Categories from './Categories';
import ArticlePreview from './ArticlePreview';
import Preloader from 'components/Preloader';
import AdwertImage from 'components/AdwertImage';
import Button from 'components/Button';
import ROUTES from 'config/routes';


const Articles = props => {
  const { articles, categories, handlePaginationChange, dataPage, isAuth } = props;
  const seo = dataPage?.seo;

  const title = dataPage?.content?.title;

  return (
    <>
      {
        seo &&
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords}></meta>
          <meta property="og:title" content={seo.title} />
          <meta property="og:description" content={seo.description} />
          <meta property="og:site_name" content={process.env.REACT_APP_NAME} />
        </Helmet>
      }
      <div className="page-body">
        <PageTitle align="center">
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </PageTitle>

        <div className="content-container">
          <div className="container">
            <div className="row flex-lg-row-reverse">
              <div className="col-12 col-lg-4">
                <div className="left-bar-container">
                  <Categories />

                  {
                    dataPage && dataPage.banners && dataPage.banners.map(item => {
                      return (<AdwertImage
                        key={item.id}
                        img={`${item.image}`}
                        url={item.url} />);
                    })
                  }
                </div>
              </div>

              <div className="col-12 col-lg-8">
                {articles.isLoading ? (
                  <Preloader />
                ) :
                  articles.list.length > 0
                    ? articles.list.map(article => (
                      <ArticlePreview
                        key={article.id}
                        article={article}
                        category={categories.find(
                          c => c.id === article.article_category_id
                        )}
                      />
                    ))
                    : <div className="content-block">
                      <p>Sorry, no articles for this category yet!</p>
                    </div>
                }

                {isAuth && articles.pagination.total > articles.pagination.items && (
                  <Pagination
                    page={articles.pagination.page}
                    perPage={articles.pagination.items}
                    total={articles.pagination.total}
                    onChange={handlePaginationChange}
                  />
                )}
              </div>
            </div>

            {
              !isAuth &&
              <div className="text-center">
                <Button bgColor="green" to={ROUTES.signUp}>Register to see more</Button>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(
  state => {
    return {
      isAuth: state.auth.isAuth,
    }
  },
)(Articles);
